const defaultState = {
  rooms: [],
  room: null,
  quiz: null,
  quizs: [],
  quiz_statistic: [],
  quiz_student_answers: [],
  loaded_quizs: false,
}


const statistic = (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_STATISTIC_ROOMS':
      return {...state, 
        rooms: action.data
      }
    case 'SET_STATISTIC_ROOMS_LOADED_QUIZS':
      return {...state, 
        loaded_quizs: action.data
      }  
    case 'SET_STATISTIC_ROOM':
      return {
        ...state, 
        room: action.data,
        quiz: null,
        quiz_student_answers: [],
        quiz_statistic: [],
      }  
    case 'GET_STATISTIC_QUIZS':
      return {...state,
        quizs: action.data,
        loaded_quizs: true,
      }
    case 'SET_STATISTIC_QUIZ':
      return {
        ...state, 
        quiz: action.data,
        quiz_student_answers: []
      }   
    case 'GET_STATISTIC_QUIZ_REPORT':
      return {...state, quiz_statistic: action.data}  
    case 'GET_STATISTIC_QUIZ_STUDENT_ANSWERS':
      return {...state, quiz_student_answers: action.data}  
    default:
      return state;
  }
}

export default statistic;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducers/statistic_report.js